import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Btn } from "./common";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export function SellHolding({ p, liveActive }) {
  const [open, setOpen] = useState(false);
  const [qty, setQty] = useState(String(p.qty));
  const [busy, setBusy] = useState(false);
  const ref = Number(p.nominal_price || 0);
  const [lim, setLim] = useState(ref ? (ref * 0.997).toFixed(ref < 10 ? 3 : 2) : "");
  const [type, setType] = useState(ref ? "limit" : "market");
  const id = p.code.replace(/\W/g, "-").toLowerCase();
  const sell = async () => {
    setBusy(true);
    try { const r = await api.post("/live/holdings/sell", { code: p.code, qty: parseFloat(qty), limit_price: type === "limit" ? parseFloat(lim) : null }); toast.success(`SELL sent to Moomoo (order ${r.data.broker_order_id})`); setOpen(false); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!liveActive) return <span className="text-[11px] text-slate-600" data-testid={`sell-holding-locked-${id}`}>Sell after LIVE is activated</span>;
  return (
    <>
      <Btn variant="danger" onClick={() => { const n = Number(p.nominal_price || 0); if (n) { setLim((n * 0.997).toFixed(n < 10 ? 3 : 2)); setType("limit"); } setQty(String(p.qty)); setOpen(true); }} data-testid={`sell-holding-btn-${id}`}>Sell</Btn>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white" data-testid={`sell-holding-dialog-${id}`}>
          <DialogHeader><DialogTitle>Sell {p.code} · REAL MONEY</DialogTitle>
            <DialogDescription>Order ke Moomoo MY. Anda pegang {p.qty}. Pecahan saham (hingga 4 titik perpuluhan) dibenarkan untuk saham US.</DialogDescription></DialogHeader>
          <label className="text-xs text-slate-600">Quantity<input data-testid={`sell-holding-qty-${id}`} type="number" step="0.0001" min="0" max={p.qty} value={qty} onChange={(e) => setQty(e.target.value)} className="mono mt-1 w-full rounded-sm border border-[#E2E8F0] bg-[#F8FAFC] px-2 py-1.5 text-sm" /></label>
          <label className="text-xs text-slate-600">Jenis order<select data-testid={`sell-holding-type-${id}`} value={type} onChange={(e) => setType(e.target.value)} className="mono mt-1 w-full rounded-sm border border-[#E2E8F0] bg-[#F8FAFC] px-2 py-1.5 text-sm"><option value="limit">limit (harga semasa −0.3%, terus dijual)</option><option value="market">market</option></select></label>
          {type === "limit" && <label className="text-xs text-slate-600">Harga had<input data-testid={`sell-holding-limit-${id}`} type="number" step="any" value={lim} onChange={(e) => setLim(e.target.value)} className="mono mt-1 w-full rounded-sm border border-[#E2E8F0] bg-[#F8FAFC] px-2 py-1.5 text-sm" /></label>}
          <Btn variant="danger" disabled={busy || !(parseFloat(qty) > 0) || (type === "limit" && !(parseFloat(lim) > 0))} onClick={sell} data-testid={`sell-holding-confirm-${id}`}>{busy ? "Sending…" : `Sell ${qty} ${p.code}`}</Btn>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function HoldingSellFor({ symbol }) {
  const { data } = useFetch("/accounts/live-summary", 60000);
  const p = data?.broker_positions?.find((x) => x.symbol === symbol);
  if (!p || !data?.live_active) return null;
  return <SellHolding p={p} liveActive />;
}

let shared = { t: 0, p: null };
function useSharedLive() {
  const [d, setD] = useState(null);
  useEffect(() => {
    let alive = true;
    const get = () => {
      if (!shared.p || Date.now() - shared.t > 60000) { shared = { t: Date.now(), p: api.get("/accounts/live-summary").then((r) => r.data).catch(() => null) }; }
      shared.p.then((v) => alive && setD(v));
    };
    get();
    const iv = setInterval(get, 60000);
    return () => { alive = false; clearInterval(iv); };
  }, []);
  return d;
}

export function TradeButtons({ symbol }) {
  const data = useSharedLive();
  if (!data?.live_active || !symbol) return null;
  const p = data.broker_positions?.find((x) => x.symbol === symbol);
  return (
    <span className="inline-flex items-center gap-1" data-testid={`trade-buttons-${symbol.replace(/\W/g, "-").toLowerCase()}`}>
      <BuyBtn symbol={symbol} />
      {p && <SellHolding p={p} liveActive />}
    </span>
  );
}

function BuyBtn({ symbol }) {
  return <Btn onClick={() => window.dispatchEvent(new CustomEvent("dmi:buy", { detail: { symbol } }))} data-testid={`buy-btn-${symbol.replace(/\W/g, "-").toLowerCase()}`}>Buy</Btn>;
}
